import { Reducer } from 'redux'
import { IDetailPageState } from '../reducers'
import { DetailPageActions } from '../actions'
import { DetailPageActionTypes } from '../actions/constants'

export const createMergeReducer = <T extends object>(
  select: (a: Partial<IDetailPageState>) => T | undefined,
  initialValue: T,
  customReducer?: Reducer<T, DetailPageActions>
) =>
  ((state: T = initialValue, action: DetailPageActions) => {
    switch (action.type) {
      case DetailPageActionTypes.STORE_MERGE:
        return select(action.payload) ? Object.assign({}, state, select(action.payload)) : state
      case DetailPageActionTypes.RESET_STORE:
        return initialValue
      default:
        return customReducer ? customReducer(state, action) : state
    }
  }) as Reducer<T, DetailPageActions>
